// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Bloomberg Terminal';

interface TerminalProps {
  className?: string;
}

export function Terminal({ className }: TerminalProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label={TITLE}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{TITLE}</title>
      <path
        d="M12.7876 16.67L12.4287 16.6501V17.6072C12.4088 17.6271 12.2891 17.7069 11.99 17.7069C11.6909 17.7069 11.5713 17.6271 11.5513 17.6072V16.6501L11.1924 16.6899C9.43769 16.8495 8.3011 17.5075 8.3011 18.325C8.3011 19.3021 9.85643 20 11.99 20C14.1236 20 15.679 19.3021 15.679 18.325C15.679 17.4875 14.5424 16.8495 12.7876 16.67ZM11.5314 14.2223V7.77767C11.5314 7.33898 11.1725 7 10.7537 7H2.77767C2.33898 7 2 7.33898 2 7.77767V14.2223C2 14.6411 2.33898 15 2.77767 15H10.7537C11.1725 15 11.5314 14.6411 11.5314 14.2223ZM22 7.77767C22 7.35892 21.661 7 21.2223 7H13.2463C12.8275 7 12.4686 7.33898 12.4686 7.77767V14.2223C12.4686 14.6411 12.8076 15 13.2463 15H21.2223C21.6411 15 22 14.661 22 14.2223V7.77767Z"
        fill="currentColor"
      />
    </svg>
  );
}
